import { render, staticRenderFns } from "./OrderListTable.vue?vue&type=template&id=70badb0c&scoped=true"
import script from "./OrderListTable.vue?vue&type=script&lang=js"
export * from "./OrderListTable.vue?vue&type=script&lang=js"
import style0 from "./OrderListTable.vue?vue&type=style&index=0&id=70badb0c&prod&scoped=true&lang=css"
import style1 from "./OrderListTable.vue?vue&type=style&index=1&id=70badb0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70badb0c",
  null
  
)

export default component.exports